import React from 'react';
import PropTypes from 'prop-types';

const PlayPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M6.168 2.314A.997.997 0 0 0 6 2.868v26.263a1 1 0 0 0 1.555.833l19.697-13.132a1 1 0 0 0 0-1.664L7.555 2.037a.998.998 0 0 0-1.387.277z"
    />
  );
};

PlayPath.propTypes = {
  fill: PropTypes.string,
};

export default PlayPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/play.jsx